<template>
  <InfoPage>
    <h1 class="display-2 mt-2 mt-md-6 mt-lg-12 mb-6 text-center">{{ $t("formulaireDon.remerciementTitre") }}</h1>
    <div v-html="$t('formulaireDon.remerciementParagraphe')"></div>
    <div v-html="$t('transactionRealisee')"></div>
    <div v-if="$route.query.identifiantCollecte && $route.query.identifiantObjectif" class="mt-12">
      <v-btn
        link
        depressed
        color="primary"
        exact
        class="mb-6"
        block
        :to="{
          name: 'Objectif',
          params: { identifiantCollecte: this.$route.query.identifiantCollecte, identifiantObjectif: $route.query.identifiantObjectif },
          query: { lang: $route.query.lang, forceRefresh: true }
        }"
        :title="$t('formulaireDon.retourObjectif')"
      >
        {{ $t("formulaireDon.retourObjectif") }}
      </v-btn>
      <v-btn
        link
        depressed
        color="primary"
        exact
        class="mb-6"
        block
        :to="{
          name: 'Collecte',
          params: { identifiantCollecte: this.$route.query.identifiantCollecte },
          query: { lang: $route.query.lang, forceRefresh: true }
        }"
        :title="$t('formulaireDon.retourEvenement')"
      >
        {{ $t("formulaireDon.retourEvenement") }}
      </v-btn>
    </div>
  </InfoPage>
</template>

<script>
import InfoPage from "@/layouts/InfoPage"

export default {
  components: {
    InfoPage
  }
}
</script>

<style>
</style>